import { render, staticRenderFns } from "./caja-abierta-view.vue?vue&type=template&id=29c3f197"
import script from "./caja-abierta-view.vue?vue&type=script&lang=js"
export * from "./caja-abierta-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports